import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, vShow as _vShow, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "min-h-screen bg-gray-50" };
const _hoisted_2 = { class: "mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8" };
const _hoisted_3 = { class: "mb-8 space-y-2" };
const _hoisted_4 = { class: "text-sm font-medium uppercase tracking-wide text-gray-400" };
const _hoisted_5 = {
    key: 0,
    class: "text-gray-500"
};
const _hoisted_6 = { class: "text-3xl font-bold text-gray-900 sm:text-4xl" };
const _hoisted_7 = {
    key: 0,
    class: "text-sm text-gray-600"
};
const _hoisted_8 = { class: "text-xs text-gray-400" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { key: 1 };
const _hoisted_11 = { class: "grid gap-8 lg:grid-cols-[300px_1fr]" };
const _hoisted_12 = { class: "hidden space-y-6 lg:block" };
const _hoisted_13 = { class: "rounded-3xl bg-white p-6 shadow-sm" };
const _hoisted_14 = { class: "mb-4 flex items-center justify-between" };
const _hoisted_15 = { class: "space-y-5" };
const _hoisted_16 = { class: "mt-2" };
const _hoisted_17 = {
    key: 0,
    class: "space-y-2"
};
const _hoisted_18 = ["value"];
const _hoisted_19 = { class: "space-y-2" };
const _hoisted_20 = { class: "space-y-2" };
const _hoisted_21 = ["value"];
const _hoisted_22 = { class: "space-y-2" };
const _hoisted_23 = ["value"];
const _hoisted_24 = { class: "rounded-3xl bg-white p-6 shadow-sm" };
const _hoisted_25 = { class: "mt-4 space-y-2 hidden lg:flex lg:flex-col" };
const _hoisted_26 = { class: "rounded-full bg-gray-100 px-2 py-0.5 text-xs font-semibold text-gray-600" };
const _hoisted_27 = ["onClick"];
const _hoisted_28 = { class: "rounded-full bg-gray-100 px-2 py-0.5 text-xs font-semibold text-gray-600" };
const _hoisted_29 = { class: "lg:hidden mb-6" };
const _hoisted_30 = { class: "rounded-3xl bg-white p-4 shadow-sm" };
const _hoisted_31 = {
    key: 0,
    class: "mt-3 flex flex-wrap gap-2"
};
const _hoisted_32 = { class: "truncate max-w-[120px]" };
const _hoisted_33 = ["onClick"];
const _hoisted_34 = { class: "mt-4 rounded-3xl bg-white p-6 shadow-lg" };
const _hoisted_35 = { class: "mb-4 flex items-center justify-between" };
const _hoisted_36 = { class: "space-y-5" };
const _hoisted_37 = { class: "mt-2" };
const _hoisted_38 = {
    key: 0,
    class: "space-y-2"
};
const _hoisted_39 = ["value"];
const _hoisted_40 = { class: "space-y-2" };
const _hoisted_41 = { class: "space-y-2" };
const _hoisted_42 = ["value"];
const _hoisted_43 = { class: "space-y-2" };
const _hoisted_44 = ["value"];
const _hoisted_45 = { class: "mt-4 border-t border-dashed border-gray-200 pt-5 lg:hidden" };
const _hoisted_46 = { class: "flex flex-col text-left leading-tight" };
const _hoisted_47 = { class: "font-semibold text-gray-900" };
const _hoisted_48 = { class: "text-xs font-semibold uppercase tracking-wide text-gray-500" };
const _hoisted_49 = { class: "mt-3 space-y-2 rounded-2xl border border-gray-200 bg-white p-3 shadow-lg" };
const _hoisted_50 = { class: "text-xs font-semibold text-gray-500" };
const _hoisted_51 = ["onClick"];
const _hoisted_52 = { class: "text-xs font-semibold text-gray-500" };
const _hoisted_53 = {
    key: 0,
    class: "rounded-3xl border border-red-200 bg-red-50 p-4 text-sm text-red-700 mb-6"
};
const _hoisted_54 = { class: "flex flex-wrap items-center justify-between gap-4 rounded-3xl bg-white/80 p-4 shadow-sm mb-6" };
const _hoisted_55 = { class: "text-sm text-gray-600" };
const _hoisted_56 = { class: "font-semibold text-gray-900" };
const _hoisted_57 = { class: "font-semibold text-gray-900" };
const _hoisted_58 = {
    key: 0,
    class: "flex items-center gap-3"
};
const _hoisted_59 = ["disabled"];
const _hoisted_60 = ["disabled"];
const _hoisted_61 = {
    key: 0,
    class: "grid gap-6 sm:grid-cols-2 xl:grid-cols-3"
};
const _hoisted_62 = {
    key: 1,
    class: "rounded-3xl bg-white p-10 text-center shadow-sm"
};
const _hoisted_63 = {
    key: 2,
    class: "grid gap-6 sm:grid-cols-2 xl:grid-cols-3"
};
const _hoisted_64 = ["onClick"];
const _hoisted_65 = { class: "relative aspect-square overflow-hidden bg-white" };
const _hoisted_66 = ["src", "alt", "onLoad", "onError"];
const _hoisted_67 = {
    key: 2,
    class: "flex h-full items-center justify-center bg-gradient-to-br from-brand-pink-500/15 to-brand-violet-500/15 text-sm font-semibold uppercase tracking-wide text-brand-violet-600"
};
const _hoisted_68 = {
    key: 3,
    class: "absolute left-4 top-4 rounded-full bg-gray-900/80 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-white"
};
const _hoisted_69 = { class: "flex flex-1 flex-col gap-4 p-6" };
const _hoisted_70 = { class: "space-y-3" };
const _hoisted_71 = {
    key: 0,
    class: "text-xs font-semibold uppercase tracking-wide text-gray-500"
};
const _hoisted_72 = { class: "flex items-start justify-between gap-4" };
const _hoisted_73 = { class: "text-lg font-semibold leading-tight text-gray-900 line-clamp-2" };
const _hoisted_74 = { class: "whitespace-nowrap rounded-full bg-brand-pink-50 px-3 py-1 text-sm font-semibold text-brand-pink-600" };
const _hoisted_75 = {
    key: 0,
    class: "text-sm text-gray-600 line-clamp-3"
};
const _hoisted_76 = {
    key: 1,
    class: "flex flex-wrap items-center justify-between gap-4 rounded-3xl bg-white/80 p-4 shadow-sm"
};
const _hoisted_77 = ["disabled"];
const _hoisted_78 = { class: "flex items-center gap-2" };
const _hoisted_79 = ["disabled", "onClick"];
const _hoisted_80 = { key: 0 };
const _hoisted_81 = { key: 1 };
const _hoisted_82 = ["disabled"];
import { computed, nextTick, onMounted, reactive, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useApi } from '../composables/useApi';
import { MoneyUtils } from '../utils/MoneyUtils';
import { generateProductSlug, getCategorySlugFromProduct, slugifySegment } from '../utils/productSlug';
const DEFAULT_PER_PAGE = 12;
const DEFAULT_SORT = 'relevance';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductListingPage',
    props: {
        category: { default: '' }
    },
    setup(__props) {
        const props = __props;
        const pageSizeOptions = [12, 24, 48];
        const sortOptions = [
            { value: 'relevance', label: 'Empfohlen' },
            { value: 'price-asc', label: 'Preis aufsteigend' },
            { value: 'price-desc', label: 'Preis absteigend' },
            { value: 'name-asc', label: 'Name A-Z' },
            { value: 'name-desc', label: 'Name Z-A' }
        ];
        const filters = reactive({
            search: '',
            brand: 'all',
            availability: 'all',
            sort: DEFAULT_SORT,
            perPage: DEFAULT_PER_PAGE
        });
        const pagination = reactive({
            page: 1
        });
        const loading = ref(true);
        const loadError = ref(null);
        const resultsContainer = ref(null);
        const skipQuerySync = ref(false);
        const mobileFiltersOpen = ref(false);
        const mobileCategoryMenuOpen = ref(false);
        let router = null;
        try {
            router = useRouter();
        }
        catch (error) {
            router = null;
        }
        const { loadMenuBundle, menuItems, categories } = useApi();
        const currentCategorySlug = computed(() => props.category?.toLowerCase() ?? '');
        const normalizedProducts = computed(() => {
            const items = menuItems.value || [];
            return items
                .map((item, index) => {
                const raw = item;
                const id = String(raw._id ?? raw.id ?? '');
                if (!id) {
                    return null;
                }
                const categorySlug = resolveCategorySlug(raw);
                const categoryName = resolveCategoryName(raw);
                const brand = resolveBrand(raw);
                const priceCent = resolvePriceCent(raw);
                const description = resolveDescription(raw);
                const keywords = resolveKeywords(raw);
                const imageUrl = resolvePrimaryImage(raw);
                const isAvailable = resolveAvailability(raw);
                const sortOrder = typeof raw.sortOrder === 'number' ? raw.sortOrder : index;
                const slug = generateProductSlug(raw) || slugifySegment(raw.name ?? `produkt-${id}`);
                return {
                    id,
                    slug,
                    categorySlug,
                    categoryName,
                    name: raw.name ?? 'Produkt',
                    description,
                    brand,
                    priceCent,
                    isAvailable,
                    sortOrder,
                    keywords,
                    imageUrl,
                    raw: item
                };
            })
                .filter((product) => product !== null);
        });
        const categoryProductBase = computed(() => {
            if (!currentCategorySlug.value) {
                return normalizedProducts.value;
            }
            return normalizedProducts.value.filter((product) => product.categorySlug === currentCategorySlug.value);
        });
        const brandSearchSource = computed(() => {
            const trimmedSearch = filters.search.trim();
            if (!trimmedSearch) {
                return categoryProductBase.value;
            }
            return categoryProductBase.value.filter((product) => productMatchesSearch(product, trimmedSearch));
        });
        const availableBrands = computed(() => {
            const set = new Set();
            brandSearchSource.value.forEach((product) => {
                if (product.brand) {
                    set.add(product.brand);
                }
            });
            if (filters.brand !== 'all') {
                set.add(filters.brand);
            }
            return Array.from(set).sort((a, b) => a.localeCompare(b, 'de'));
        });
        const filteredProducts = computed(() => {
            let result = [...categoryProductBase.value];
            const trimmedSearch = filters.search.trim();
            if (trimmedSearch) {
                result = result.filter((product) => productMatchesSearch(product, trimmedSearch));
            }
            if (filters.brand !== 'all') {
                result = result.filter((product) => product.brand === filters.brand);
            }
            if (filters.availability === 'available') {
                result = result.filter((product) => product.isAvailable);
            }
            switch (filters.sort) {
                case 'price-asc':
                    result.sort((a, b) => a.priceCent - b.priceCent);
                    break;
                case 'price-desc':
                    result.sort((a, b) => b.priceCent - a.priceCent);
                    break;
                case 'name-asc':
                    result.sort((a, b) => a.name.localeCompare(b.name, 'de'));
                    break;
                case 'name-desc':
                    result.sort((a, b) => b.name.localeCompare(a.name, 'de'));
                    break;
                default:
                    result.sort((a, b) => {
                        if (a.sortOrder !== b.sortOrder) {
                            return a.sortOrder - b.sortOrder;
                        }
                        return a.name.localeCompare(b.name, 'de');
                    });
                    break;
            }
            return result;
        });
        const totalResults = computed(() => filteredProducts.value.length);
        const categoryProductCount = computed(() => categoryProductBase.value.length);
        const totalPages = computed(() => {
            if (totalResults.value === 0) {
                return 0;
            }
            return Math.ceil(totalResults.value / filters.perPage);
        });
        const currentPage = computed(() => {
            if (totalPages.value === 0) {
                return 1;
            }
            return Math.min(Math.max(1, pagination.page), totalPages.value);
        });
        const paginatedProducts = computed(() => {
            if (totalResults.value === 0) {
                return [];
            }
            const start = (currentPage.value - 1) * filters.perPage;
            return filteredProducts.value.slice(start, start + filters.perPage);
        });
        const imageLoadState = reactive({});
        const showingRange = computed(() => {
            if (totalResults.value === 0) {
                return { from: 0, to: 0 };
            }
            const start = (currentPage.value - 1) * filters.perPage;
            const end = Math.min(totalResults.value, start + paginatedProducts.value.length);
            return { from: start + 1, to: end };
        });
        const categoryNavigation = computed(() => {
            const metaMap = buildCategoryMetaMap();
            const summaries = [];
            const counts = new Map();
            normalizedProducts.value.forEach((product) => {
                const slug = product.categorySlug || 'all';
                counts.set(slug, (counts.get(slug) ?? 0) + 1);
            });
            counts.forEach((count, slug) => {
                const meta = metaMap.get(slug);
                summaries.push({
                    slug,
                    name: meta?.name ?? formatCategoryLabel(slug),
                    description: meta?.description ?? '',
                    count,
                    sortOrder: meta?.sortOrder ?? 0
                });
            });
            summaries.sort((a, b) => {
                if (a.sortOrder !== b.sortOrder) {
                    return a.sortOrder - b.sortOrder;
                }
                return a.name.localeCompare(b.name, 'de');
            });
            return summaries;
        });
        const activeCategory = computed(() => {
            if (!currentCategorySlug.value) {
                return {
                    slug: '',
                    name: 'Alle Produkte',
                    description: 'Stöbere durch unser komplettes Sortiment.',
                    count: normalizedProducts.value.length,
                    sortOrder: -Infinity
                };
            }
            const match = categoryNavigation.value.find((category) => category.slug === currentCategorySlug.value);
            if (match) {
                return match;
            }
            return {
                slug: currentCategorySlug.value,
                name: formatCategoryLabel(currentCategorySlug.value),
                description: '',
                count: categoryProductCount.value,
                sortOrder: 0
            };
        });
        const hasActiveFilters = computed(() => {
            return (filters.search.trim().length > 0 ||
                filters.brand !== 'all' ||
                filters.availability !== 'all');
        });
        const activeFilterBadges = computed(() => {
            const badges = [];
            if (filters.search.trim()) {
                badges.push({
                    key: 'search',
                    label: `Suche: ${filters.search.trim()}`,
                    onRemove: () => removeFilterBadge('search')
                });
            }
            if (filters.brand !== 'all') {
                badges.push({
                    key: 'brand',
                    label: `Marke: ${filters.brand}`,
                    onRemove: () => removeFilterBadge('brand')
                });
            }
            if (filters.availability !== 'all') {
                const label = filters.availability === 'available' ? 'Nur verfügbare' : 'Verfügbarkeit';
                badges.push({
                    key: 'availability',
                    label,
                    onRemove: () => removeFilterBadge('availability')
                });
            }
            if (filters.sort !== DEFAULT_SORT) {
                const optionLabel = sortOptions.find((option) => option.value === filters.sort)?.label;
                if (optionLabel) {
                    badges.push({
                        key: 'sort',
                        label: `Sortierung: ${optionLabel}`,
                        onRemove: () => removeFilterBadge('sort')
                    });
                }
            }
            if (filters.perPage !== DEFAULT_PER_PAGE) {
                badges.push({
                    key: 'perPage',
                    label: `Pro Seite: ${filters.perPage}`,
                    onRemove: () => removeFilterBadge('perPage')
                });
            }
            return badges;
        });
        const paginationItems = computed(() => {
            const total = totalPages.value;
            if (total <= 1) {
                return [];
            }
            if (total <= 7) {
                return Array.from({ length: total }, (_, index) => index + 1);
            }
            const items = [1];
            if (currentPage.value > 3) {
                items.push('ellipsis');
            }
            const start = Math.max(2, currentPage.value - 1);
            const end = Math.min(total - 1, currentPage.value + 1);
            for (let number = start; number <= end; number += 1) {
                items.push(number);
            }
            if (currentPage.value < total - 2) {
                items.push('ellipsis');
            }
            items.push(total);
            return items;
        });
        onMounted(async () => {
            try {
                loading.value = true;
                if (!menuItems.value.length) {
                    const bundle = await loadMenuBundle();
                    if (!bundle) {
                        loadError.value = 'Produkte konnten nicht geladen werden.';
                    }
                }
                await syncStateFromQuery();
            }
            catch (error) {
                loadError.value = error instanceof Error ? error.message : 'Unbekannter Fehler';
                console.error('[ProductListingPage] Failed to load products', error);
            }
            finally {
                loading.value = false;
            }
        });
        watch(() => props.category, async () => {
            await syncStateFromQuery();
        });
        watch(availableBrands, async (brands) => {
            if (filters.brand !== 'all' && !brands.includes(filters.brand)) {
                skipQuerySync.value = true;
                filters.brand = 'all';
                await nextTick();
                skipQuerySync.value = false;
                updateUrlFromState();
            }
        });
        watch(() => [filters.search, filters.brand, filters.availability, filters.sort], () => {
            if (skipQuerySync.value) {
                return;
            }
            if (pagination.page !== 1) {
                pagination.page = 1;
                return;
            }
            updateUrlFromState();
        });
        watch(() => filters.perPage, () => {
            if (skipQuerySync.value) {
                return;
            }
            if (!pageSizeOptions.includes(filters.perPage)) {
                filters.perPage = DEFAULT_PER_PAGE;
                return;
            }
            if (pagination.page !== 1) {
                pagination.page = 1;
                return;
            }
            updateUrlFromState();
        });
        watch(() => totalPages.value, async (total) => {
            if (skipQuerySync.value) {
                return;
            }
            const target = total === 0 ? 1 : Math.min(pagination.page, total);
            if (pagination.page !== target) {
                skipQuerySync.value = true;
                pagination.page = target;
                await nextTick();
                skipQuerySync.value = false;
                updateUrlFromState();
            }
        });
        watch(() => pagination.page, async (newValue) => {
            if (skipQuerySync.value) {
                return;
            }
            if (newValue < 1) {
                pagination.page = 1;
                return;
            }
            updateUrlFromState();
            await nextTick();
            scrollResultsIntoView();
        });
        watch(paginatedProducts, (products) => {
            products.forEach((product) => {
                if (!Object.prototype.hasOwnProperty.call(imageLoadState, product.id)) {
                    imageLoadState[product.id] = false;
                }
            });
        }, { immediate: true });
        function categoryButtonClass(slug) {
            const isActive = slug === currentCategorySlug.value || (!slug && !currentCategorySlug.value);
            return {
                'border-brand-pink-400 bg-brand-pink-50 text-brand-pink-700 shadow-sm': isActive,
                'border-gray-200 bg-white text-gray-600 hover:border-brand-pink-200 hover:bg-brand-pink-50 hover:text-brand-pink-600': !isActive
            };
        }
        function paginationButtonClass(item) {
            if (item === 'ellipsis') {
                return 'cursor-default border border-transparent text-gray-400';
            }
            const isActive = item === currentPage.value;
            if (isActive) {
                return 'border-brand-pink-500 bg-brand-pink-500 text-white shadow-md';
            }
            return 'border border-gray-200 bg-white text-gray-700 hover:border-brand-pink-200 hover:bg-brand-pink-50';
        }
        function goToPreviousPage() {
            if (pagination.page > 1) {
                pagination.page -= 1;
            }
        }
        function goToNextPage() {
            if (pagination.page < totalPages.value) {
                pagination.page += 1;
            }
        }
        function goToPage(page) {
            if (page >= 1 && page <= totalPages.value) {
                pagination.page = page;
            }
        }
        function resetFilters() {
            filters.search = '';
            filters.brand = 'all';
            filters.availability = 'all';
            filters.sort = DEFAULT_SORT;
            filters.perPage = DEFAULT_PER_PAGE;
        }
        function removeFilterBadge(key) {
            switch (key) {
                case 'search':
                    filters.search = '';
                    break;
                case 'brand':
                    filters.brand = 'all';
                    break;
                case 'availability':
                    filters.availability = 'all';
                    break;
                case 'sort':
                    filters.sort = DEFAULT_SORT;
                    break;
                case 'perPage':
                    filters.perPage = DEFAULT_PER_PAGE;
                    break;
                default:
                    break;
            }
        }
        function navigateToCategory(slug) {
            if (typeof window === 'undefined') {
                return;
            }
            const basePath = '/produkte';
            const trimmed = slug?.trim();
            const path = trimmed ? `${basePath}/${trimmed}/` : `${basePath}/`;
            const query = buildQueryFromState();
            delete query.page;
            if (router) {
                router.push({ path, query });
                return;
            }
            const queryString = buildQueryString(query);
            const targetUrl = queryString ? `${path}?${queryString}` : path;
            window.location.href = targetUrl;
        }
        function handleProductClick(product) {
            if (typeof window === 'undefined') {
                return;
            }
            const categorySegment = product.categorySlug ? `${product.categorySlug}/` : '';
            const path = `/produkte/${categorySegment}${product.slug}/${product.id}`;
            window.location.href = path;
        }
        function toggleMobileCategoryMenu() {
            mobileCategoryMenuOpen.value = !mobileCategoryMenuOpen.value;
        }
        function selectMobileCategory(slug) {
            mobileCategoryMenuOpen.value = false;
            navigateToCategory(slug);
        }
        function scrollResultsIntoView() {
            if (typeof window === 'undefined') {
                return;
            }
            const target = resultsContainer.value;
            if (target) {
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            else {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }
        function markImageLoaded(productId) {
            imageLoadState[productId] = true;
        }
        function imageClass(productId) {
            return imageLoadState[productId] ? 'opacity-100' : 'opacity-0';
        }
        function buildQueryFromState() {
            const query = {};
            const trimmedSearch = filters.search.trim();
            if (trimmedSearch) {
                query.search = trimmedSearch;
            }
            if (filters.brand !== 'all') {
                query.brand = filters.brand;
            }
            if (filters.availability !== 'all') {
                query.availability = filters.availability;
            }
            if (filters.sort !== DEFAULT_SORT) {
                query.sort = filters.sort;
            }
            if (filters.perPage !== DEFAULT_PER_PAGE) {
                query.perPage = String(filters.perPage);
            }
            if (pagination.page > 1) {
                query.page = String(pagination.page);
            }
            return query;
        }
        async function syncStateFromQuery() {
            if (typeof window === 'undefined') {
                return;
            }
            skipQuerySync.value = true;
            const url = new URL(window.location.href);
            const searchParam = url.searchParams.get('search') ?? url.searchParams.get('q');
            const brand = url.searchParams.get('brand');
            const availability = url.searchParams.get('availability');
            const sort = url.searchParams.get('sort');
            const perPage = url.searchParams.get('perPage');
            const page = url.searchParams.get('page');
            filters.search = searchParam ?? '';
            filters.brand = brand ?? 'all';
            filters.availability = availability === 'available' ? 'available' : 'all';
            filters.sort = sortOptions.some((option) => option.value === sort) ? String(sort) : DEFAULT_SORT;
            const parsedPerPage = perPage ? Number.parseInt(perPage, 10) : DEFAULT_PER_PAGE;
            filters.perPage = pageSizeOptions.includes(parsedPerPage) ? parsedPerPage : DEFAULT_PER_PAGE;
            const parsedPage = page ? Number.parseInt(page, 10) : 1;
            pagination.page = Number.isInteger(parsedPage) && parsedPage > 0 ? parsedPage : 1;
            await nextTick();
            skipQuerySync.value = false;
            updateUrlFromState();
        }
        function updateUrlFromState() {
            if (typeof window === 'undefined' || skipQuerySync.value) {
                return;
            }
            const query = buildQueryFromState();
            const url = new URL(window.location.href);
            url.search = '';
            Object.entries(query).forEach(([key, value]) => {
                url.searchParams.set(key, value);
            });
            const updatedUrl = `${url.pathname}${url.search}${url.hash}`;
            window.history.replaceState({}, '', updatedUrl);
        }
        function buildQueryString(query) {
            const params = new URLSearchParams();
            Object.entries(query).forEach(([key, value]) => {
                if (value) {
                    params.set(key, value);
                }
            });
            return params.toString();
        }
        function buildCategoryMetaMap() {
            const map = new Map();
            const list = categories.value || [];
            list.forEach((category, index) => {
                const slug = slugifySegment(category.slug ?? category.id ?? category.name ?? `category-${index}`);
                map.set(slug, {
                    name: category.name ?? formatCategoryLabel(slug),
                    description: category.description ?? '',
                    sortOrder: typeof category.sortOrder === 'number' ? category.sortOrder : index
                });
            });
            return map;
        }
        function productMatchesSearch(product, query) {
            const normalizedQuery = query.toLowerCase();
            const haystack = [
                product.name,
                product.brand ?? '',
                product.categoryName,
                ...product.keywords
            ]
                .join(' ')
                .toLowerCase();
            return haystack.includes(normalizedQuery);
        }
        function resolveCategorySlug(item) {
            const slug = getCategorySlugFromProduct(item);
            if (slug) {
                return slugifySegment(slug);
            }
            if (item.category && typeof item.category === 'object') {
                if (item.category.slug) {
                    return slugifySegment(item.category.slug);
                }
                if (item.category.name) {
                    return slugifySegment(item.category.name);
                }
            }
            if (typeof item.category === 'string') {
                return slugifySegment(item.category);
            }
            if (item.categoryName) {
                return slugifySegment(item.categoryName);
            }
            return '';
        }
        function resolveCategoryName(item) {
            if (item.categoryName) {
                return item.categoryName;
            }
            if (item.category && typeof item.category === 'object' && item.category.name) {
                return item.category.name;
            }
            if (typeof item.category === 'string') {
                return item.category;
            }
            return 'Produkt';
        }
        function resolveBrand(item) {
            return item.brand ?? item.manufacturer ?? item.producer ?? null;
        }
        function resolvePriceCent(item) {
            if (typeof item.priceCent === 'number') {
                return item.priceCent;
            }
            if (typeof item.price === 'number') {
                return Math.round(item.price * 100);
            }
            return 0;
        }
        function resolveDescription(item) {
            if (typeof item.shortDescription === 'string' && item.shortDescription.trim()) {
                return item.shortDescription.trim();
            }
            if (typeof item.description === 'string' && item.description.trim()) {
                return item.description.trim();
            }
            return '';
        }
        function resolveKeywords(item) {
            const keywords = [];
            if (Array.isArray(item.keywords)) {
                keywords.push(...item.keywords.map((keyword) => String(keyword)));
            }
            if (Array.isArray(item.tags)) {
                keywords.push(...item.tags.map((tag) => String(tag)));
            }
            return keywords.filter((keyword) => keyword && keyword.trim());
        }
        function resolvePrimaryImage(item) {
            const imageData = item.imageData;
            if (imageData?.baseUrl) {
                const type = imageData.type || 'webp';
                return `${imageData.baseUrl}_original.${type}`;
            }
            if (Array.isArray(item.images) && item.images.length > 0) {
                const firstImage = item.images[0];
                if (typeof firstImage === 'string' && firstImage.trim()) {
                    return firstImage.trim();
                }
            }
            if (typeof item.image === 'string' && item.image.trim()) {
                return item.image.trim();
            }
            if (typeof item.imageUrl === 'string' && item.imageUrl.trim()) {
                return item.imageUrl.trim();
            }
            return null;
        }
        function resolveAvailability(item) {
            if (item.isAvailable === false) {
                return false;
            }
            if (item.isVisible === false) {
                return false;
            }
            if (typeof item.availability === 'string') {
                return item.availability !== 'unavailable';
            }
            return true;
        }
        function formatCategoryLabel(slug) {
            return slug
                .split('-')
                .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
                .join(' ');
        }
        function formatPrice(value) {
            return MoneyUtils.formatCurrency(value);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("p", _hoisted_4, [
                            _cache[13] || (_cache[13] = _createTextVNode(" Produkte ", -1 /* CACHED */)),
                            (currentCategorySlug.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "→ " + _toDisplayString(activeCategory.value.name), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("h1", _hoisted_6, _toDisplayString(activeCategory.value.name), 1 /* TEXT */),
                        (activeCategory.value.description)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(activeCategory.value.description), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                        _createElementVNode("p", _hoisted_8, [
                            (totalResults.value === categoryProductCount.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(totalResults.value) + " Produkte gefunden", 1 /* TEXT */))
                                : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(totalResults.value) + " von " + _toDisplayString(categoryProductCount.value) + " Produkten nach Filterung angezeigt ", 1 /* TEXT */))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("aside", _hoisted_12, [
                            _createElementVNode("section", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                    _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "text-lg font-semibold text-gray-900" }, "Filter", -1 /* CACHED */)),
                                    (hasActiveFilters.value)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            type: "button",
                                            class: "text-sm font-medium text-brand-pink-600 transition hover:text-brand-pink-500",
                                            onClick: resetFilters
                                        }, " Zurücksetzen "))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("div", null, [
                                        _cache[15] || (_cache[15] = _createElementVNode("label", {
                                            class: "text-sm font-medium text-gray-700",
                                            for: "filter-search"
                                        }, "Suche", -1 /* CACHED */)),
                                        _createElementVNode("div", _hoisted_16, [
                                            _withDirectives(_createElementVNode("input", {
                                                id: "filter-search",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((filters.search) = $event)),
                                                type: "search",
                                                placeholder: "Produkt, Marke oder Stichwort",
                                                class: "w-full rounded-2xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-900 shadow-sm transition focus:border-brand-pink-400 focus:outline-none focus:ring-2 focus:ring-brand-pink-200"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [_vModelText, filters.search]
                                            ])
                                        ])
                                    ]),
                                    (availableBrands.value.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                            _cache[17] || (_cache[17] = _createElementVNode("label", {
                                                class: "text-sm font-medium text-gray-700",
                                                for: "filter-brand"
                                            }, "Hersteller", -1 /* CACHED */)),
                                            _withDirectives(_createElementVNode("select", {
                                                id: "filter-brand",
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((filters.brand) = $event)),
                                                class: "w-full rounded-2xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-900 shadow-sm transition focus:border-brand-pink-400 focus:outline-none focus:ring-2 focus:ring-brand-pink-200"
                                            }, [
                                                _cache[16] || (_cache[16] = _createElementVNode("option", { value: "all" }, "Alle Hersteller", -1 /* CACHED */)),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableBrands.value, (brand) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        key: brand,
                                                        value: brand
                                                    }, _toDisplayString(brand), 9 /* TEXT, PROPS */, _hoisted_18));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ], 512 /* NEED_PATCH */), [
                                                [_vModelSelect, filters.brand]
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createElementVNode("div", _hoisted_19, [
                                        _cache[19] || (_cache[19] = _createElementVNode("label", {
                                            class: "text-sm font-medium text-gray-700",
                                            for: "filter-availability"
                                        }, "Verfügbarkeit", -1 /* CACHED */)),
                                        _withDirectives(_createElementVNode("select", {
                                            id: "filter-availability",
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((filters.availability) = $event)),
                                            class: "w-full rounded-2xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-900 shadow-sm transition focus:border-brand-pink-400 focus:outline-none focus:ring-2 focus:ring-brand-pink-200"
                                        }, [...(_cache[18] || (_cache[18] = [
                                                _createElementVNode("option", { value: "all" }, "Alle Produkte", -1 /* CACHED */),
                                                _createElementVNode("option", { value: "available" }, "Nur verfügbare Produkte", -1 /* CACHED */)
                                            ]))], 512 /* NEED_PATCH */), [
                                            [_vModelSelect, filters.availability]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_20, [
                                        _cache[20] || (_cache[20] = _createElementVNode("label", {
                                            class: "text-sm font-medium text-gray-700",
                                            for: "filter-sort"
                                        }, "Sortierung", -1 /* CACHED */)),
                                        _withDirectives(_createElementVNode("select", {
                                            id: "filter-sort",
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((filters.sort) = $event)),
                                            class: "w-full rounded-2xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-900 shadow-sm transition focus:border-brand-pink-400 focus:outline-none focus:ring-2 focus:ring-brand-pink-200"
                                        }, [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sortOptions, (option) => {
                                                return _createElementVNode("option", {
                                                    key: option.value,
                                                    value: option.value
                                                }, _toDisplayString(option.label), 9 /* TEXT, PROPS */, _hoisted_21);
                                            }), 64 /* STABLE_FRAGMENT */))
                                        ], 512 /* NEED_PATCH */), [
                                            [_vModelSelect, filters.sort]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_22, [
                                        _cache[21] || (_cache[21] = _createElementVNode("label", {
                                            class: "text-sm font-medium text-gray-700",
                                            for: "filter-page-size"
                                        }, "Produkte pro Seite", -1 /* CACHED */)),
                                        _withDirectives(_createElementVNode("select", {
                                            id: "filter-page-size",
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((filters.perPage) = $event)),
                                            class: "w-full rounded-2xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-900 shadow-sm transition focus:border-brand-pink-400 focus:outline-none focus:ring-2 focus:ring-brand-pink-200"
                                        }, [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(pageSizeOptions, (option) => {
                                                return _createElementVNode("option", {
                                                    key: option,
                                                    value: option
                                                }, _toDisplayString(option) + " Produkte ", 9 /* TEXT, PROPS */, _hoisted_23);
                                            }), 64 /* STABLE_FRAGMENT */))
                                        ], 512 /* NEED_PATCH */), [
                                            [
                                                _vModelSelect,
                                                filters.perPage,
                                                void 0,
                                                { number: true }
                                            ]
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("section", _hoisted_24, [
                                _createElementVNode("nav", _hoisted_25, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: _normalizeClass(["flex w-full items-center justify-between rounded-2xl border px-4 py-2.5 text-sm font-medium transition", categoryButtonClass('')]),
                                        onClick: _cache[5] || (_cache[5] = ($event) => (navigateToCategory('')))
                                    }, [
                                        _cache[22] || (_cache[22] = _createElementVNode("span", null, "Alle Produkte", -1 /* CACHED */)),
                                        _createElementVNode("span", _hoisted_26, _toDisplayString(normalizedProducts.value.length), 1 /* TEXT */)
                                    ], 2 /* CLASS */),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryNavigation.value, (category) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                            key: category.slug,
                                            type: "button",
                                            class: _normalizeClass(["flex w-full items-center justify-between rounded-2xl border px-4 py-2.5 text-sm font-medium transition", categoryButtonClass(category.slug)]),
                                            onClick: ($event) => (navigateToCategory(category.slug))
                                        }, [
                                            _createElementVNode("span", null, _toDisplayString(category.name), 1 /* TEXT */),
                                            _createElementVNode("span", _hoisted_28, _toDisplayString(category.count), 1 /* TEXT */)
                                        ], 10 /* CLASS, PROPS */, _hoisted_27));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ])
                            ])
                        ]),
                        _createElementVNode("main", null, [
                            _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "flex w-full items-center justify-between rounded-3xl border border-gray-200 px-4 py-3 text-sm font-semibold text-gray-700 transition hover:border-brand-pink-200 hover:bg-gray-50",
                                        onClick: _cache[6] || (_cache[6] = ($event) => (mobileFiltersOpen.value = !mobileFiltersOpen.value))
                                    }, [
                                        _cache[24] || (_cache[24] = _createElementVNode("span", null, "Filter anzeigen", -1 /* CACHED */)),
                                        (_openBlock(), _createElementBlock("svg", {
                                            class: _normalizeClass(["h-5 w-5 transition-transform", { 'rotate-180': mobileFiltersOpen.value }]),
                                            fill: "none",
                                            stroke: "currentColor",
                                            viewBox: "0 0 24 24"
                                        }, [...(_cache[23] || (_cache[23] = [
                                                _createElementVNode("path", {
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "2",
                                                    d: "M6 9l6 6 6-6"
                                                }, null, -1 /* CACHED */)
                                            ]))], 2 /* CLASS */))
                                    ]),
                                    (activeFilterBadges.value.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeFilterBadges.value, (badge) => {
                                                return (_openBlock(), _createElementBlock("span", {
                                                    key: badge.key,
                                                    class: "flex items-center gap-2 rounded-full bg-gray-100 px-3 py-1 text-xs font-semibold text-gray-600 shadow-sm"
                                                }, [
                                                    _createElementVNode("span", _hoisted_32, _toDisplayString(badge.label), 1 /* TEXT */),
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "flex h-5 w-5 items-center justify-center rounded-full bg-white text-[11px] font-bold text-gray-500 transition hover:bg-brand-pink-50 hover:text-brand-pink-600",
                                                        onClick: badge.onRemove
                                                    }, " × ", 8 /* PROPS */, _hoisted_33)
                                                ]));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _withDirectives(_createElementVNode("section", _hoisted_34, [
                                        _createElementVNode("div", _hoisted_35, [
                                            _cache[25] || (_cache[25] = _createElementVNode("h2", { class: "text-lg font-semibold text-gray-900" }, "Filter", -1 /* CACHED */)),
                                            (hasActiveFilters.value)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    type: "button",
                                                    class: "text-sm font-medium text-brand-pink-600 transition hover:text-brand-pink-500",
                                                    onClick: resetFilters
                                                }, " Zurücksetzen "))
                                                : _createCommentVNode("v-if", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_36, [
                                            _createElementVNode("div", null, [
                                                _cache[26] || (_cache[26] = _createElementVNode("label", {
                                                    class: "text-sm font-medium text-gray-700",
                                                    for: "mobile-filter-search"
                                                }, "Suche", -1 /* CACHED */)),
                                                _createElementVNode("div", _hoisted_37, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        id: "mobile-filter-search",
                                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((filters.search) = $event)),
                                                        type: "search",
                                                        placeholder: "Produkt, Marke oder Stichwort",
                                                        class: "w-full rounded-2xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-900 shadow-sm transition focus:border-brand-pink-400 focus:outline-none focus:ring-2 focus:ring-brand-pink-200"
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelText, filters.search]
                                                    ])
                                                ])
                                            ]),
                                            (availableBrands.value.length)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                                    _cache[28] || (_cache[28] = _createElementVNode("label", {
                                                        class: "text-sm font-medium text-gray-700",
                                                        for: "mobile-filter-brand"
                                                    }, "Hersteller", -1 /* CACHED */)),
                                                    _withDirectives(_createElementVNode("select", {
                                                        id: "mobile-filter-brand",
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((filters.brand) = $event)),
                                                        class: "w-full rounded-2xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-900 shadow-sm transition focus:border-brand-pink-400 focus:outline-none focus:ring-2 focus:ring-brand-pink-200"
                                                    }, [
                                                        _cache[27] || (_cache[27] = _createElementVNode("option", { value: "all" }, "Alle Hersteller", -1 /* CACHED */)),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableBrands.value, (brand) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                key: brand,
                                                                value: brand
                                                            }, _toDisplayString(brand), 9 /* TEXT, PROPS */, _hoisted_39));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ], 512 /* NEED_PATCH */), [
                                                        [_vModelSelect, filters.brand]
                                                    ])
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            _createElementVNode("div", _hoisted_40, [
                                                _cache[30] || (_cache[30] = _createElementVNode("label", {
                                                    class: "text-sm font-medium text-gray-700",
                                                    for: "mobile-filter-availability"
                                                }, "Verfügbarkeit", -1 /* CACHED */)),
                                                _withDirectives(_createElementVNode("select", {
                                                    id: "mobile-filter-availability",
                                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((filters.availability) = $event)),
                                                    class: "w-full rounded-2xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-900 shadow-sm transition focus:border-brand-pink-400 focus:outline-none focus:ring-2 focus:ring-brand-pink-200"
                                                }, [...(_cache[29] || (_cache[29] = [
                                                        _createElementVNode("option", { value: "all" }, "Alle Produkte", -1 /* CACHED */),
                                                        _createElementVNode("option", { value: "available" }, "Nur verfügbare Produkte", -1 /* CACHED */)
                                                    ]))], 512 /* NEED_PATCH */), [
                                                    [_vModelSelect, filters.availability]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_41, [
                                                _cache[31] || (_cache[31] = _createElementVNode("label", {
                                                    class: "text-sm font-medium text-gray-700",
                                                    for: "mobile-filter-sort"
                                                }, "Sortierung", -1 /* CACHED */)),
                                                _withDirectives(_createElementVNode("select", {
                                                    id: "mobile-filter-sort",
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((filters.sort) = $event)),
                                                    class: "w-full rounded-2xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-900 shadow-sm transition focus:border-brand-pink-400 focus:outline-none focus:ring-2 focus:ring-brand-pink-200"
                                                }, [
                                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sortOptions, (option) => {
                                                        return _createElementVNode("option", {
                                                            key: option.value,
                                                            value: option.value
                                                        }, _toDisplayString(option.label), 9 /* TEXT, PROPS */, _hoisted_42);
                                                    }), 64 /* STABLE_FRAGMENT */))
                                                ], 512 /* NEED_PATCH */), [
                                                    [_vModelSelect, filters.sort]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_43, [
                                                _cache[32] || (_cache[32] = _createElementVNode("label", {
                                                    class: "text-sm font-medium text-gray-700",
                                                    for: "mobile-filter-page-size"
                                                }, "Produkte pro Seite", -1 /* CACHED */)),
                                                _withDirectives(_createElementVNode("select", {
                                                    id: "mobile-filter-page-size",
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((filters.perPage) = $event)),
                                                    class: "w-full rounded-2xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-900 shadow-sm transition focus:border-brand-pink-400 focus:outline-none focus:ring-2 focus:ring-brand-pink-200"
                                                }, [
                                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(pageSizeOptions, (option) => {
                                                        return _createElementVNode("option", {
                                                            key: option,
                                                            value: option
                                                        }, _toDisplayString(option) + " Produkte ", 9 /* TEXT, PROPS */, _hoisted_44);
                                                    }), 64 /* STABLE_FRAGMENT */))
                                                ], 512 /* NEED_PATCH */), [
                                                    [
                                                        _vModelSelect,
                                                        filters.perPage,
                                                        void 0,
                                                        { number: true }
                                                    ]
                                                ])
                                            ])
                                        ])
                                    ], 512 /* NEED_PATCH */), [
                                        [_vShow, mobileFiltersOpen.value]
                                    ]),
                                    _createElementVNode("div", _hoisted_45, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "flex w-full items-center justify-between rounded-2xl border border-gray-200 bg-gray-50 px-4 py-3 text-sm font-semibold text-gray-700 transition hover:border-brand-pink-200 hover:bg-white",
                                            onClick: toggleMobileCategoryMenu
                                        }, [
                                            _createElementVNode("div", _hoisted_46, [
                                                _createElementVNode("span", _hoisted_47, _toDisplayString(activeCategory.value.name), 1 /* TEXT */),
                                                _createElementVNode("small", _hoisted_48, _toDisplayString(activeCategory.value.count) + " Artikel ", 1 /* TEXT */)
                                            ]),
                                            (_openBlock(), _createElementBlock("svg", {
                                                class: _normalizeClass(["h-4 w-4 transition-transform", { 'rotate-180': mobileCategoryMenuOpen.value }]),
                                                fill: "none",
                                                stroke: "currentColor",
                                                viewBox: "0 0 24 24"
                                            }, [...(_cache[33] || (_cache[33] = [
                                                    _createElementVNode("path", {
                                                        "stroke-linecap": "round",
                                                        "stroke-linejoin": "round",
                                                        "stroke-width": "2",
                                                        d: "M19 9l-7 7-7-7"
                                                    }, null, -1 /* CACHED */)
                                                ]))], 2 /* CLASS */))
                                        ]),
                                        _withDirectives(_createElementVNode("div", _hoisted_49, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: _normalizeClass(["flex w-full items-center justify-between rounded-xl px-4 py-2 text-left text-sm text-gray-700 transition hover:bg-brand-pink-50", { 'text-brand-pink-600 font-semibold': !currentCategorySlug.value }]),
                                                onClick: _cache[12] || (_cache[12] = ($event) => (selectMobileCategory('')))
                                            }, [
                                                _cache[34] || (_cache[34] = _createElementVNode("span", null, "Alle Produkte", -1 /* CACHED */)),
                                                _createElementVNode("span", _hoisted_50, _toDisplayString(normalizedProducts.value.length), 1 /* TEXT */)
                                            ], 2 /* CLASS */),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryNavigation.value, (category) => {
                                                return (_openBlock(), _createElementBlock("button", {
                                                    key: category.slug,
                                                    type: "button",
                                                    class: _normalizeClass(["flex w-full items-center justify-between rounded-xl px-4 py-2 text-left text-sm text-gray-700 transition hover:bg-brand-pink-50", { 'text-brand-pink-600 font-semibold': category.slug === currentCategorySlug.value }]),
                                                    onClick: ($event) => (selectMobileCategory(category.slug))
                                                }, [
                                                    _createElementVNode("span", null, _toDisplayString(category.name), 1 /* TEXT */),
                                                    _createElementVNode("span", _hoisted_52, _toDisplayString(category.count), 1 /* TEXT */)
                                                ], 10 /* CLASS, PROPS */, _hoisted_51));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ], 512 /* NEED_PATCH */), [
                                            [_vShow, mobileCategoryMenuOpen.value]
                                        ])
                                    ])
                                ])
                            ]),
                            (loadError.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(loadError.value), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                            _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("p", _hoisted_55, [
                                    (totalResults.value > 0)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _cache[35] || (_cache[35] = _createTextVNode(" Zeigt ", -1 /* CACHED */)),
                                            _createElementVNode("span", _hoisted_56, _toDisplayString(showingRange.value.from) + "–" + _toDisplayString(showingRange.value.to), 1 /* TEXT */),
                                            _cache[36] || (_cache[36] = _createTextVNode(" von ", -1 /* CACHED */)),
                                            _createElementVNode("span", _hoisted_57, _toDisplayString(totalResults.value), 1 /* TEXT */),
                                            _cache[37] || (_cache[37] = _createTextVNode(" Produkten ", -1 /* CACHED */))
                                        ], 64 /* STABLE_FRAGMENT */))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode(" Keine Produkte gefunden. Passe deine Filter an. ")
                                        ], 64 /* STABLE_FRAGMENT */))
                                ]),
                                (totalPages.value > 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: _normalizeClass(["rounded-full border border-gray-200 px-4 py-2 text-sm font-medium text-gray-700 transition hover:border-gray-300 hover:bg-gray-50", { 'cursor-not-allowed opacity-50': pagination.page === 1 }]),
                                            disabled: pagination.page === 1,
                                            onClick: goToPreviousPage
                                        }, " Zurück ", 10 /* CLASS, PROPS */, _hoisted_59),
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: _normalizeClass(["rounded-full border border-gray-200 px-4 py-2 text-sm font-medium text-gray-700 transition hover:border-gray-300 hover:bg-gray-50", { 'cursor-not-allowed opacity-50': pagination.page >= totalPages.value }]),
                                            disabled: pagination.page >= totalPages.value,
                                            onClick: goToNextPage
                                        }, " Weiter ", 10 /* CLASS, PROPS */, _hoisted_60)
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _createElementVNode("div", {
                                ref_key: "resultsContainer",
                                ref: resultsContainer
                            }, [
                                (loading.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filters.perPage, (index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: `skeleton-${index}`,
                                                class: "animate-pulse rounded-3xl bg-white/80 p-6 shadow-sm"
                                            }, [...(_cache[38] || (_cache[38] = [
                                                    _createStaticVNode("<div class=\"aspect-square rounded-2xl bg-gray-100\"></div><div class=\"mt-5 space-y-3\"><div class=\"h-4 w-3/4 rounded-full bg-gray-200\"></div><div class=\"h-4 w-1/2 rounded-full bg-gray-100\"></div><div class=\"h-8 w-2/3 rounded-full bg-gray-200\"></div></div>", 2)
                                                ]))]));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]))
                                    : (paginatedProducts.value.length === 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                            _cache[39] || (_cache[39] = _createElementVNode("h2", { class: "text-xl font-semibold text-gray-900" }, "Keine Produkte gefunden", -1 /* CACHED */)),
                                            _cache[40] || (_cache[40] = _createElementVNode("p", { class: "mt-2 text-sm text-gray-600" }, " Es wurden keine Produkte gefunden, die deinen Filtern entsprechen. Versuche, die Filter zurückzusetzen oder andere Suchbegriffe zu verwenden. ", -1 /* CACHED */)),
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "mt-6 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-brand-pink-500 to-brand-violet-500 px-5 py-2.5 text-sm font-semibold text-white transition hover:shadow-lg",
                                                onClick: resetFilters
                                            }, " Filter zurücksetzen ")
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedProducts.value, (product) => {
                                                return (_openBlock(), _createElementBlock("article", {
                                                    key: product.id,
                                                    class: "group relative flex h-full cursor-pointer flex-col overflow-hidden rounded-3xl border-2 border-gray-100 bg-white/95 shadow-sm transition duration-300 hover:-translate-y-1.5 hover:border-brand-pink-300 hover:shadow-lg",
                                                    onClick: ($event) => (handleProductClick(product))
                                                }, [
                                                    _createElementVNode("div", _hoisted_65, [
                                                        (product.imageUrl)
                                                            ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                                                key: 0,
                                                                class: _normalizeClass(["pointer-events-none absolute inset-4 flex items-center justify-center rounded-2xl bg-gradient-to-br from-gray-100 via-white to-gray-200", { 'animate-pulse': !imageLoadState[product.id] }]),
                                                                role: "presentation"
                                                            }, [...(_cache[41] || (_cache[41] = [
                                                                    _createElementVNode("span", { class: "h-10 w-10 rounded-full bg-gray-200" }, null, -1 /* CACHED */)
                                                                ]))], 2 /* CLASS */)), [
                                                                [_vShow, !imageLoadState[product.id]]
                                                            ])
                                                            : _createCommentVNode("v-if", true),
                                                        (product.imageUrl)
                                                            ? (_openBlock(), _createElementBlock("img", {
                                                                key: 1,
                                                                src: product.imageUrl,
                                                                alt: product.name,
                                                                loading: "lazy",
                                                                class: _normalizeClass(["h-full w-full object-contain p-4 transition duration-500 group-hover:scale-105", imageClass(product.id)]),
                                                                onLoad: ($event) => (markImageLoaded(product.id)),
                                                                onError: ($event) => (markImageLoaded(product.id))
                                                            }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_66))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_67, _toDisplayString(product.categoryName || 'Produkt'), 1 /* TEXT */)),
                                                        (!product.isAvailable)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_68, " Ausverkauft "))
                                                            : _createCommentVNode("v-if", true)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_69, [
                                                        _createElementVNode("div", _hoisted_70, [
                                                            (product.brand)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_71, _toDisplayString(product.brand), 1 /* TEXT */))
                                                                : _createCommentVNode("v-if", true),
                                                            _createElementVNode("div", _hoisted_72, [
                                                                _createElementVNode("h3", _hoisted_73, _toDisplayString(product.name), 1 /* TEXT */),
                                                                _createElementVNode("span", _hoisted_74, _toDisplayString(formatPrice(product.priceCent)), 1 /* TEXT */)
                                                            ])
                                                        ]),
                                                        (product.description)
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_75, _toDisplayString(product.description), 1 /* TEXT */))
                                                            : _createCommentVNode("v-if", true)
                                                    ])
                                                ], 8 /* PROPS */, _hoisted_64));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ]))
                            ], 512 /* NEED_PATCH */),
                            (totalPages.value > 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: _normalizeClass(["rounded-full border border-gray-200 px-4 py-2 text-sm font-medium text-gray-700 transition hover:border-gray-300 hover:bg-gray-50", { 'cursor-not-allowed opacity-50': pagination.page === 1 }]),
                                        disabled: pagination.page === 1,
                                        onClick: goToPreviousPage
                                    }, " Zurück ", 10 /* CLASS, PROPS */, _hoisted_77),
                                    _createElementVNode("div", _hoisted_78, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginationItems.value, (item) => {
                                            return (_openBlock(), _createElementBlock("button", {
                                                key: `page-${item}`,
                                                type: "button",
                                                class: _normalizeClass(["flex h-10 w-10 items-center justify-center rounded-full text-sm font-semibold transition", paginationButtonClass(item)]),
                                                disabled: item === 'ellipsis',
                                                onClick: ($event) => (typeof item === 'number' && goToPage(item))
                                            }, [
                                                (item === 'ellipsis')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_80, "…"))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_81, _toDisplayString(item), 1 /* TEXT */))
                                            ], 10 /* CLASS, PROPS */, _hoisted_79));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: _normalizeClass(["rounded-full border border-gray-200 px-4 py-2 text-sm font-medium text-gray-700 transition hover:border-gray-300 hover:bg-gray-50", { 'cursor-not-allowed opacity-50': pagination.page >= totalPages.value }]),
                                        disabled: pagination.page >= totalPages.value,
                                        onClick: goToNextPage
                                    }, " Weiter ", 10 /* CLASS, PROPS */, _hoisted_82)
                                ]))
                                : _createCommentVNode("v-if", true)
                        ])
                    ])
                ])
            ]));
        };
    }
});
